import { render, staticRenderFns } from "./StatisticsCard.vue?vue&type=template&id=07d75334&scoped=true&"
import script from "./StatisticsCard.vue?vue&type=script&lang=ts&"
export * from "./StatisticsCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticsCard.vue?vue&type=style&index=0&id=07d75334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d75334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
